// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment, { isMoment } from 'moment';
import Header from './Header';
import Day from './Day';
import DayGrid from './DayGrid';
import colors from '../../../../ui/colors';
import { calendarMonthDates } from '../../../../utils/date-utils';

const StyledCalendar = styled.div`
  ${props =>
    props.visible &&
    props.visible === false &&
    `
    display: none;
  `} position: absolute;
  background-color: white;
  border: 1px solid ${colors.GRAY};
  border-radius: 5px;
  overflow: hidden;
  right: 0;
  min-width: 300px;
  max-width: 320px;
  z-index: 1;
  box-shadow: rgba(0, 0, 0, 0.21) 0 2px 4px;
  color: ${colors.GRAY};

  &.full-width {
    max-width: 100%;
  }
`;

class Calendar extends Component {
  static propTypes = {
    onMonthChange: PropTypes.func,
    visible: PropTypes.bool,
  };

  static defaultProps = {
    HeaderComponent: Header,
    DayComponent: Day,
    visible: false,
  };

  state = {};

  constructor(props) {
    super(props);

    const currentMonth = isMoment(props.currentMonth) && props.currentMonth.isValid() ? props.currentMonth : moment();
    const firstSelectableDate =
      isMoment(props.firstPossibleDate) && props.firstPossibleDate.isValid()
        ? props.firstPossibleDate
        : moment(props.firstPossibleDate).startOf('day');
    const lastSelectableDate =
      isMoment(props.lastPossibleDate) && props.lastPossibleDate.isValid()
        ? props.lastPossibleDate
        : moment(props.lastPossibleDate).startOf('day');

    this.state = {
      currentMonth,
      firstSelectableDate,
      lastSelectableDate,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.currentMonth !== nextProps.currentMonth) {
      const currentMonth =
        isMoment(nextProps.currentMonth) && nextProps.currentMonth.isValid() ? nextProps.currentMonth : moment();
      this.setState({
        currentMonth,
      });
    }
    if (this.props.firstPossibleDate !== nextProps.firstPossibleDate) {
      const firstSelectableDate =
        isMoment(nextProps.firstPossibleDate) && nextProps.firstPossibleDate.isValid()
          ? nextProps.firstPossibleDate
          : moment(nextProps.firstPossibleDate).startOf('day');
      this.setState({
        firstSelectableDate,
      });
    }
    if (this.props.lastPossibleDate !== nextProps.lastPossibleDate) {
      const lastSelectableDate =
        isMoment(nextProps.lastPossibleDate) && nextProps.lastPossibleDate.isValid()
          ? nextProps.lastPossibleDate
          : moment(nextProps.lastPossibleDate).startOf('day');
      this.setState({
        lastSelectableDate,
      });
    }
  }

  triggerMonthChange = () => {
    if (this.props.onMonthChange) {
      this.props.onMonthChange(this.state.currentMonth);
    }
  };

  handlePrev = e => {
    e.stopPropagation();
    e.preventDefault();
    e.nativeEvent.stopImmediatePropagation();
    const currentMonth = this.state.currentMonth.clone().subtract(1, 'month');
    this.setState(
      {
        currentMonth,
      },
      this.triggerMonthChange
    );
  };

  handleNext = e => {
    e.stopPropagation();
    e.preventDefault();
    e.nativeEvent.stopImmediatePropagation();
    const currentMonth = this.state.currentMonth.clone().add(1, 'month');
    this.setState(
      {
        currentMonth,
      },
      this.triggerMonthChange
    );
  };

  checkDisabled = date => {
    return false;
    // const initialCheck = !isSameMonth(date, this.state.currentMonth) || isAfterToday(date);
    // let doubleCheck = true;
    // const { firstSelectableDate, lastSelectableDate } = this.state;
    // if(firstSelectableDate && lastSelectableDate) {
    // 	doubleCheck &= !isInRange(date, firstSelectableDate, lastSelectableDate);
    // };
    // return initialCheck || !!doubleCheck;
  };

  checkPrevMonthDisabled = () => {
    return false;
    // return this.state.currentMonth.clone().subtract(1, 'month').isBefore(this.state.firstSelectableDate, 'month');
  };

  checkNextMonthDisabled = () => {
    return false;
    // const thisMonth = moment();
    // return this.state.currentMonth.clone().add(1, 'month').isAfter(thisMonth, 'month') || this.state.currentMonth.clone().add(1, 'month').isAfter(this.state.lastSelectableDate, 'month');
  };

  render() {
    const visibleDates = calendarMonthDates(this.state.currentMonth);
    const { className, DayComponent, HeaderComponent, visible } = this.props;
    const onClick = e => {
      e.preventDefault();
      e.nativeEvent.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
    };

    return (
      <StyledCalendar className={className} visible={visible} onClick={onClick}>
        <HeaderComponent
          handlePrev={this.handlePrev}
          handleNext={this.handleNext}
          currentMonth={this.state.currentMonth}
          prevDisabled={this.checkPrevMonthDisabled()}
          nextDisabled={this.checkNextMonthDisabled()}
          showDateRanges={true}
        />
        <DayGrid>
          {visibleDates.map((date, i) => {
            return <DayComponent key={i} date={date} disabled={this.checkDisabled(date)} blocked={false} />;
          })}
        </DayGrid>
      </StyledCalendar>
    );
  }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/modules/common/components/calendar/Calendar.js